
  import { Component, Vue } from 'vue-property-decorator';
  import CashbookTemplateGrid
    from "@/components/admin/CashbookEntryTemplate/CashbookTemplateGrid.vue";

  @Component({
    components: {
      CashbookTemplateGrid,
    },
  })
  export default class CashbookEntryTemplatesMobile extends Vue {
    onViewItem (item) {
      this.$emit("ViewItem", item);
    }
    onEditItem (item) {
      this.$emit("EditItem", item);
    }
    onDeleteItem (item) {
      this.$emit("DeleteItem", item);
    }
    onAddItem () {
      this.$emit("AddItem");
    }
  }
